import { render, staticRenderFns } from "./Co44Page.vue?vue&type=template&id=e00c3e2c"
import script from "./Co44Page.vue?vue&type=script&lang=js"
export * from "./Co44Page.vue?vue&type=script&lang=js"
import style0 from "./Co44Page.vue?vue&type=style&index=0&id=e00c3e2c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports